// extracted by mini-css-extract-plugin
module.exports = {"bar":"GanttChart_bar__1XsAq","circle":"GanttChart_circle__2CEBu","labelBg":"GanttChart_labelBg__WnqgU"};